import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/pages/404.scss';

const NotFound = () => {
    document.body.classList = "template-404 whiteBg";
    return(
        <div className="innerWrapper lightOrangeBg tac">
            <div className="big-404-text">
                <span>4</span>
                <span data-text="0">0</span>
                <span>4</span>
            </div>
            <div className="bottom-section">
                <p>Oops!</p>
                <h4>Sorry We can’t find that page!</h4>
                <span>Either something went wrong or the page<br/> Doesn’t exist anymore.</span>
                <Link to="/" className="btn pill white sm">Go to home</Link>
            </div>
        </div>
    )
}

export default NotFound;